module.exports = __webpack_public_path__ + "static/media/eusko_jaurlaritza.908306cf.png";